// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpsertOrganizationBrandingDTO
 */
export interface UpsertOrganizationBrandingDTO {
    /**
     * 
     * @type {string}
     * @memberof UpsertOrganizationBrandingDTO
     */
    friendlyOrganizationName: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrganizationBrandingDTO
     */
    emailFooterText: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrganizationBrandingDTO
     */
    emailHeaderLogoKey: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrganizationBrandingDTO
     */
    emailHeaderLogoContentType: UpsertOrganizationBrandingDTOEmailHeaderLogoContentTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpsertOrganizationBrandingDTOEmailHeaderLogoContentTypeEnum {
    Png = 'image/png',
    Jpeg = 'image/jpeg'
}



